import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditPostedComponent } from './edit-posted.component';
import { AutocompletePayorsModule } from 'app/utils/autocomplete-payors/autocomplete-payors.module';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    AutocompletePayorsModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [EditPostedComponent],
  exports: [EditPostedComponent],
  providers: [ConciliationService, T2LoadingService]
})
export class EditPostedModuleModule { }



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/deposits/posted/edit-posted/edit-posted-module.module.ts